import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";
import db, { query, collection, where, getDocs,onSnapshot,addDoc } from "../firebase";
import "./PlansScreen.css";
import {loadStripe} from '@stripe/stripe-js'

function PlansScreen() {
  const [products, setProducts] = useState([]);
  const user = useSelector(selectUser);
  useEffect(() => {
    const q = query(collection(db, "products"), where("active", "==", true));
    const docs = async () => {
      const querySnapShot = await getDocs(q);
      const products = {};
      querySnapShot.forEach(async (doc) => {
        products[doc.id] = doc.data();
        const prices = collection(doc,"prices");
        const priceSnap = await getDocs(prices);
        priceSnap.docs.forEach((doc) => {
          products[doc.id].prices = {
            priceId: priceSnap.id,
            priceData: priceSnap.data(),
          };
        });
      });
      setProducts(products);
    };
    docs();
  }, []);
  console.log(products);
  const loadCheckout = async (priceId) => {
    const docRef = await addDoc(collection(db,`customers/${user.uid}/checkout_sessions`),{
        price: priceId,
        success_url: window.location.origin,
        cancel_url: window.location.origin,
    })
    onSnapshot(docRef,async(snap) => {
        const {error, sessionId} = snap.data();
        if (error) {
             // Show an error to your customer and
          // inspect your Cloud Function logs in the Firebase console.
          alert(`An error occured: ${error.message}`);
        }
        if (sessionId) {
            // We have a Stripe Checkout URL, let's redirect.
            const stripe = await loadStripe('pk_test_51LIJjVAjPNO6SdtEeYuHScoXnKjFAnXcP2DOk5vri6a1PhUFXgYqU2735g9UKJUQ69zu5cyHv1betruD6xKqmfQP00uVugZvld')
            stripe.redirectToCheckout({sessionId})
          }
    })
  };
  loadCheckout();
  return (
    <div className="plansScreen">
      {Object.entries(products).map(([productId, productData]) => {
        // Add some logic to check if the user's subscription is active
        return (
          <div key={productId} className="plansScreen__plan">
            <div className="plansScreen__info">
              <h5>{productData.name}</h5>
              <h6>{productData.description}</h6>
            </div>
            <button onClick={loadCheckout(productData?.prices?.priceId)}>
              Subscribe
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default PlansScreen;
